import { PropsWithChildren } from 'react';
import { Box, useTheme } from '@cdl/heartbeat-react';

export const Overlay: React.FC<PropsWithChildren> = ({ children, ...rest }) => {
  const theme = useTheme();
  return (
    <Box
      position='absolute'
      top={0}
      right={0}
      bottom={0}
      left={0}
      backgroundColor={`${theme.colors.neutral[900]}4D`}
      borderRadius='4px'
      sx={{
        marginTop: '0 !important',
      }}
      {...rest}
    >
      {children}
    </Box>
  );
};
